import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabaseConfigError = !supabaseUrl || !supabaseKey
  ? "Supabase環境変数が設定されていません。.env.local と Cloudflare Pages の環境変数を確認してください。"
  : "";

export const supabase = supabaseConfigError
  ? null
  : createClient(supabaseUrl, supabaseKey);
